import axios from "axios";
import { routes } from "../utils/mappers";
import {
  createProductFormData,
  createUpdateEntrepreneurFormData,
} from "../utils/payloads";

const baseURL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_MERCADIM_BASE_URL_PRO
    : process.env.REACT_APP_MERCADIM_BASE_URL_DEV;

// const baseURL = "http://mercadim.ifce.edu.br/";

export const api = axios.create({
  baseURL: baseURL + "api",
  headers: {
    Accept: "application/json",
  },
});

// export const apiPDF = axios.create({
//   baseURL: "http://localhost:8000/api",
//   headers: {
//     Accept: "application/pdf"
//   }
// })

export function getImage(image, id) {
  return `${baseURL}storage/${id}/${image}`;
}

getImage("product.jpg");

export async function getPaymentsMethod() {
  const result = await api.get("/paymentsMethod");

  return result.data;
}

export async function paymentMethod(name) {
  const result = await api.post("/paymentMethod", name);

  return result.data;
}

export async function getPaymentMethod(id) {
  const result = await api.get(`/paymentMethod/${id}`);

  return result.data;
}

export async function updatePaymentMethod(payment) {
  const result = await api.post(`/paymentMethod/update/${payment.id}`, payment);

  return result.data;
}

export function setBearerToken(token) {
  api.defaults.headers.Authorization = `Bearer ${token}`;
  // apiPDF.defaults.headers.Authorization = `Bearer ${token}`;
}

export function clearBearerToken() {
  delete api.defaults.headers.Authorization;
  // delete apiPDF.defaults.headers.Authorization;
}

export async function signupUser(user, type) {
  const response = await api.post(routes.signup[type], user);

  return response.data;
}

export async function loginUser(user, type) {
  const response = await api.post("/login", user);

  return response.data;
}

export async function loginGoogle(user) {
  const response = await api.post("/loginGoogle", user);

  return response.data;
}

export async function searchGiftVouchersCityCategory(
  data,
  page = 1,
  ascOrDesc = "ASC"
) {
  const result = await api.post("/searchGiftVoucherInCity", data, {
    params: {
      page,
      ascOrDesc,
    },
  });
  return result.data;
}

export async function searchPartners(
  data,
  page = 1,
  ascOrDesc = "ASC"
) {
  const result = await api.post("/getAllPartners", data, {
    params: {
      page,
      ascOrDesc,
    },
  });
  return result.data;
}

//Pegando todos os vale presentes
export async function getAllGifts(page = 1) {
  const result = await api.get("/giftVouchers/entrepreneur", {
    params: {
      page,
    },
  });
  return result.data;
}

export async function searchGift(query, page = 1) {
  const result = await api.post(
    "/giftVouchers/entrepreneur/search",
    {
      nameValePresente: query,
    },
    {
      params: {
        page,
      },
    }
  );

  return result.data;
}

//Cadastrando um vale presente
export async function AddGiftVoucher(data) {
  try {
    await api.post("/giftVoucher/entrepreneur", data);
    return { success: true };
  } catch (err) {
    return { success: false };
  }
}

//Pegando um vale presente
export async function getGift(id) {
  const result = await api.get(`/giftVoucher/entrepreneur/${id}`);
  return {
    ...result.data,
    type: "giftVoucher",
  };
}

//Atualizando vale presente
export async function updateGiftVoucher(gift) {
  try {
    await api.post(`/giftVoucher/entrepreneur/update/${gift.id}`, gift);

    return { updated: true };
  } catch (err) {
    return { updated: false };
  }
}

//Deletando um vale presente
export async function deleteGift(id) {
  const result = await api.delete(`/delete/giftVoucher/entrepreneur/${id}`);
  return result.data;
}

// Pegando todos os admins
export async function getAllAdmins(page = 1) {
  const result = await api.get("/admins", { params: { page } });
  return result.data;
}

export async function getAdmin(id) {
  const result = await api.get(`/admin/${id}`);

  return result.data;
}

//Cadastrando uma admin
export async function AddAdmin(data) {
  const result = await api.post("/admin", data);

  return result.data;
}

//Deletando um admin
export async function deleteAdmin(user) {
  try {
    await api.delete(`/admin/delete/${user.id}`);
  } catch (err) { }
}

// Pegando todos os usuários
export async function getAllUsers(page = 1) {
  const result = await api.get("/users", {
    params: { page },
  });

  return result.data;
}
export async function getThemeSettings() {
  const result = await api.get("/theme/settings");

  return result.data;
}

export async function updateThemeSettings(payload) {
  const result = await api.post("/theme/settings", payload);

  return result.data;
}
export async function getAllGruposAdmin(tipo = null, page = 1) {
  const result = await api.get("/grupos", {
    params: {
      page,
      ...(tipo ? { tipo } : {}) // só envia se for definido
    },
  });
  return result.data;
}
export async function deleteGrupo(ids) {
  return Promise.all(
    ids.map((id) =>
      api.delete(`/grupos/${id}`)
    )
  );
}

export async function exportGruposToGoogleSheets(ids) {
  // Aqui entraria a integração real com a API do Google Sheets
  console.log("Exportar para edição em massa:", ids);
}
export async function importGruposFromFile(file) {
  const formData = new FormData();
  formData.append("file", file);
  const result = await api.post("/grupos/import", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return result.data;
}
export async function updateGrupo(id, data) {
  // data precisa conter { nome, url, tipo }
  const result = await api.post(`/grupos/update/${id}`, data);
  return result.data;
}

export async function searchGrupo(query, tipo = null) {
  const result = await api.post("/grupos/search", {
    nome: query,
    ...(tipo ? { tipo } : {})
  });
  return result.data;
}
//Pegando um usuário
export async function getUser(id) {
  const result = await api.get(`/user/${id}`);

  return result.data;
}
export async function createGrupo(data) {
  console.log(data);
  const result = await api.post("/grupos", data);
  return result.data;
}


export async function searchUser(query, page = 1) {
  // name only
  const isCPF = /^\d{11}$/.test(query);

  if (isCPF) {
    try {
      const result = await api.post("/user/cpf", { cpfUser: query });
      return { data: [result.data] };
    } catch (err) {
      return { data: [] };
    }
  } else {
    const result = await api.post("/user/search", { nameUser: query, page });
    return result.data;
  }
}

export async function searchAdmin(query, page = 1) {
  // name only
  const result = await api.post("/admin/search", {
    nameAdmin: query,
    page,
  });

  return result.data;
}

export async function searchEntrepreneur(query, page = 1) {
  // name only
  const isCNPJ = /^\d{14}$/.test(query);
  const isCPF = /^\d{11}$/.test(query);

  if (isCPF || isCNPJ) {
    try {
      const result = await api.post("/entrepreneur/cpfcnpj", {
        cpf_cnpj: query,
      });
      return { data: result.data };
    } catch (err) {
      return { data: [] };
    }
  } else {
    const result = await api.post("/entrepreneur/search", {
      name_establishment: query,
      page,
    });

    return result.data;
  }
}

export async function getGeneralRole() {
  const result = await api.get("/roleGeneral");

  return result.data;
}

export async function logoutUser(role) {
  await api.post(routes.logout[role]);
}

export async function searchPayment(query) {
  const result = await api.post("/paymentMethod/search", {
    namePayment: query,
  });

  return result.data;
}

export async function searchCategory(query) {
  const result = await api.post("/categories/search", {
    nameCategory: query,
  });

  return result.data;
}
export async function searchEvento(query) {
  const result = await api.post("/search/evento", {
    nameCategory: query,
  });

  return result.data;
}

export async function searchRibbonBadges(query) {
  const result = await api.post("/ribbonBadges/search", {
    name: query,
  });

  return result.data;
}

export async function searchCategoryType(query) {
  const result = await api.post("/categoriesType/search", {
    nameCategory: query,
  });

  return result.data;
}

export async function searchPartner(query) {
  const result = await api.post("/partner/search", {
    nameCategory: query,
  });

  return result.data;
}
export async function searchPessoas(query) {
  const result = await api.post("/divulgacao/search", {
    name: query,
  });

  return result.data;
}

export async function searchLocation(query, page = 1) {
  const result = await api.post("/city/search", { nameCity: query, page });
  return result.data;
}

export async function getProductsCity(query) {
  const result = await api.post("/products/city", {
    city: query,
  });
  return result.data[0];
}

export async function updateCategory(category) {
  const result = await api.post(`/categories/update/${category.id}`, category);

  return result.data;
}

export async function updateRibbonBadge(category) {
  const result = await api.post(`/ribbonBadgesUp/${category.id}`, category);

  return result.data;
}

export async function updateCategoryType(category) {
  const result = await api.post(`/categoriesType/update/${category.id}`, category);

  return result.data;
}
export async function updatePartner(partner, id) {
  const result = await api.post(`/partner/update/${id}`, partner);

  return result.data;
}
export async function updatePessoas(partner, id) {
  const result = await api.post(`/divulgacao/update/${id}`, partner);

  return result.data;
}
export async function updateBanner(partner, id) {
  const result = await api.post(`/banner/update/${id}`, partner);

  return result.data;
}

export async function getDashboardAdmin(month, year) {
  const result = await api.post("/dashboard/admin", {
    year,
    month,
  });

  return result.data;
}

export async function getDashboardEntrepreneur() {
  const result = await api.get("/dashboard/entrepreneur");

  return result.data;
}

export async function getDashboardEntrepreneurFilterByMonthYear(month, year) {
  const result = await api.post("/dashboard/filterByMonthYear", {
    year,
    month,
  });

  return result.data;
}

export async function getDashboardAdminFilterByMonthYear(month, year) {
  const result = await api.post("/dashboard/admin/filterByMonthYear", {
    year,
    month,
  });

  return result.data;
}

export async function getCategory(id) {
  const result = await api.get(`/category/${id}`);

  return result.data;
}

export async function getRibonBadges(id) {
  const result = await api.get(`/ribbonBadge/${id}`);

  return result.data;
}

export async function getCategoryType(id) {
  const result = await api.get(`/categoriesTypes/${id}`);

  return result.data;
}

export async function getPartner(id) {
  const response = await api.get(`partner/${id}`);
  return response.data;
}

export async function getDivulgacao(id) {
  const response = await api.get(`divulgacao/${id}`);
  return response.data;
}

export async function getBanner(id) {
  const response = await api.get(`showBanner/${id}`);
  return response.data;
}

export async function productsCategory(id) {
  const result = await api.get(`/products/category/${id}`);
  return result.data;
}

export async function getProductReviews(id) {
  const result = await api.get(`/listReviews/${id}`);

  return result.data;
}

export async function getProductReviewsSlug(slug) {
  const result = await api.get(`/listReviews/slug/${slug}`);

  return result.data;
}

export async function reviewProduct(review) {
  const result = await api.post("/evaluateTheProduct", review);

  return result.data;
}

export async function updateReview(id, review) {
  const result = await api.post(`/editReview/${id}`, review);

  return result.data;
}

export async function deleteReview(review) {
  try {
    await api.delete(`/deleteReview/${review.id}`);
  } catch (err) { }
}

//Cadastrando uma usuário
export async function AddUser(data) {
  const result = await api.post("/user", data);

  return result.data;
}

//Atualizando um usuário
export async function updateUser(user) {
  const id = user.id;

  if (user.password.length === 0) {
    delete user.password;
  }

  let status = false;

  await api.post(`/user/update/${id}`, user).then(
    (res) => {
      if (res.data.id) {
        status = true;
      }
    },
    (err) => {
      // const msg = Object.values(err.response.data.erros).map((m) =>
      //   m.toString()
      // );
      status = false;
    }
  );
  return status;
}

export async function updateAdmin(admin) {
  try {
    await api.post(`/admin/update/${admin.id}`, admin);

    return { updated: true };
  } catch (err) {
    return { updated: false };
  }
}

//Deletando um usuário
export async function deleteUser(user) {
  try {
    await api.delete(`/user/delete/${user.id}`);
  } catch (err) { }
}

export async function getCidades(uf) {
  const result = await api.get(`/citys/${uf}`);
  console.log(result.data);
  return result.data;
}

//Pegando todos os empreendedores
export async function getAllEnterpreneurs(page = 1) {
  const result = await api.get(`/entrepreneurs`, { params: { page } });
  return result.data;
}

//Pegando um empreendedor
export async function getEntrepreneur(id) {
  const result = await api.get(`/entrepreneur/${id}`);

  return result.data;
}

//Cadastrando uma empreendedor
export async function AddEntrepreneur(data) {
  const result = await api.post("/entrepreneur", data);

  return result.data;
}

//Atualizando um empreendedor
export async function updateEntrepreneur(user) {
  try {
    await api.post(
      `/entrepreneur/update/${user.id}`,
      createUpdateEntrepreneurFormData(user)
    );

    return { updated: true };
  } catch (err) {
    return { updated: false };
  }
}

//Deletando um empreendedor
export async function deleteEntrepreneur(user) {
  try {
    await api.delete(`/entrepreneur/delete/${user.id}`);
  } catch (err) { }
}

//Pegando os produtos do empreendedor
export async function getProductsEntrepreneur(page = 1) {
  const result = await api.get("/products/entrepreneur", {
    params: {
      page,
    },
  });
  return result.data;
}

export async function getAllProductsAdmin(page = 1) {
  const result = await api.get("/allProductsAdmin", {
    params: {
      page,
    },
  });
  return result.data;
}

export async function searchProductsEntrepreneur(query, page = 1) {
  const result = await api.post("/products/entrepreneur/search", {
    nameProduto: query,
    page,
  });

  return result.data;
}

export async function searchProductsAdmin(query, page = 1) {
  const result = await api.post("/products/admin/search", {
    nameProduto: query,
    page,
  });

  return result.data;
}

//Cadastrando um produto do empreendedor
export async function AddProductEntrepreneur(data) {
  try {
    const response = await api.post("/product/entrepreneur", data);
    return response.data; // 🔹 retorna exatamente o JSON do backend
  } catch (err) {
    return { success: false, error: err };
  }
}

export async function analyzeProductOfferWithAi(data) {
  const response = await api.post("/product/entrepreneur/assistant/analyze", data);
  return response.data;
}

export async function AddPartner(data) {
  try {
    await api.post("/partner", data);
    return { success: true };
  } catch (err) {
    return { success: false };
  }
}

export async function AddPeople(data) {
  try {
    await api.post("/divulgacao/cad", data);
    return { success: true };
  } catch (err) {
    return { success: false };
  }
}

export async function AddBanner(data) {
  try {
    await api.post("/banner", data);
    return { success: true };
  } catch (err) {
    return { success: false };
  }
}

//Pesquisando um produto
export async function searchProduct(query, page = 1) {
  // name only
  const result = await api.post("/products/search", {
    nameProduto: query,
    page,
  });
  return result.data[0];
}
export async function searchProductInCityCategory(
  data,
  page = 1,
  ascOrDesc = "DESC"
) {
  const result = await api.post("/searchProductInCity", data, {
    params: {
      page,
      ascOrDesc,
    },
  });
  return result.data;
}

export async function getHighlightedProducts() {
  const result = await api.get("/products/highlighted");
  return result.data;
}

// Ofertas capturadas do WhatsApp (página pública Ofertas Ao Vivo)
export async function getOfertasAoVivo({ limit = 100 } = {}) {
  const result = await api.get("/ofertas-ao-vivo", { params: { limit } });
  return result.data;
}

export async function createOfertaAoVivo(payload) {
  const result = await api.post("/ofertas-ao-vivo", payload);
  return result.data;
}

export async function updateOfertaAoVivo(id, payload) {
  const result = await api.put(`/ofertas-ao-vivo/${id}`, payload);
  return result.data;
}

export async function addOfertaAoVivoToLive(id) {
  const result = await api.post(`/ofertas-ao-vivo/${id}/add-live`);
  return result.data;
}

export async function deleteOfertaAoVivo(id) {
  const result = await api.delete(`/ofertas-ao-vivo/${id}`);
  return result.data;
}

export async function clearOfertasAoVivo(board) {
  const result = await api.post("/ofertas-ao-vivo/clear", { board });
  return result.data;
}

export async function setOfertaDestaque(id, destaque) {
  const result = await api.post(`/ofertas-ao-vivo/${id}/destaque`, { destaque });
  return result.data;
}

// Cupons ativos (barra lateral Ofertas Ao Vivo)
export async function getCupons() {
  const result = await api.get("/cupons");
  return result.data;
}

export async function createCupom(payload) {
  const result = await api.post("/cupons", payload);
  return result.data;
}

export async function updateCupom(id, payload) {
  const result = await api.put(`/cupons/${id}`, payload);
  return result.data;
}

export async function deleteCupom(id) {
  const result = await api.delete(`/cupons/${id}`);
  return result.data;
}

export async function getLinkPreview(url) {
  const result = await api.get("/link-preview", { params: { url } });
  return result.data;
}

//Deletando um produto do empreendedor
export async function deleteProduct(prod) {
  try {
    await api.delete(`/delete/product/entrepreneur/${prod.id}`);
  } catch (err) { }
}

export async function duplicateOffer(prod) {
  try {
    return await api.post(`/product/entrepreneur/duplicate`, {
      id: prod.id
    });
  } catch (err) { }
}

export async function deletesProducts(id) {
  try {
    return await api.post(`/deletesProduts`, {
      ids: id
    });
  } catch (err) { }
}

export async function markProductsAsEnded(ids, encerrada) {
  const response = await api.post("/products/mark-ended", {
    ids,
    encerrada: encerrada ? 1 : 0,
  });
  return response.data;
}

//Pegando todas os produtos
export async function getAllProducts(page = 1) {
  const result = await api.get("/products", {
    params: { page },
  });
  return result.data.products;
}

export async function getAllImagesProducts({ search = "" } = {}) {
  const payload = {};

  if (typeof search === "string" && search.trim() !== "") {
    payload.search = search.trim();
  }

  const result = await api.post("/listarImagensProdutos", payload);

  return result.data;
}



export async function getProduct(id) {
  const result = await api.get(`/product/entrepreneur/${id}`);
  return {
    ...result.data,
    type: "product",
  };
}

export async function getProductSlug(slug) {
  const result = await api.get(`/product/slug/${slug}`);
  return {
    ...result.data,
    type: "product",
  };
}

export async function updateProduct(product) {
  try {
    await api.post(
      `/product/entrepreneur/update/${product.id}`,
      createProductFormData(product)
    );
    return true;
  } catch (err) {
    return false;
  }
}

//Pegando todas as categorias
export async function getAllCategories(page = 1) {
  const result = await api.get("/categories", {
    params: {
      page,
    },

  });
  return result.data.categories;
}

export async function getAllCategorisAdmin(page = 1) {
  const result = await api.get("/allCategorysAdmin", {
    params: {
      page,
    },

  });
  return result.data.categories;

}
export async function getEventoAdmin(page = 1) {
  const result = await api.get("/evento", {
    params: {
      page,
    },

  });
  return result.data.categories;

}

export async function getAllRibbonBadges(page = 1) {
  const result = await api.get("/ribbonBadgesAll", {
    params: {
      page,
    },

  });
  return result.data;

}

export async function getAllCategoriesTypes(page = 1) {
  const result = await api.get("/categoriesTypes", {
    params: {
      page,
    },
  });

  return result.data.categories;
}
//allTypes

export async function getAllTypes(page = 1) {
  const result = await api.get("/allTypes", {
    params: {
      page,
    },
  });

  return result.data.categories;
}
export async function getAllPartiners(includeSystem = false) {
  const result = await api.get("/partners", {
    params: includeSystem ? { include_system: 1 } : {},
  });
  return result.data.partners;
}

export async function getAllDivugacao() {
  const result = await api.get("/divulgacao");
  return result.data.divulgacao;
}

export async function getAllPessoas() {
  const result = await api.get("/pessoasDivulgacao");
  return result.data.divulgacao;
}

export async function getAllBanners() {
  const result = await api.get("/allBanners");
  return result.data.banners;
}

export async function activeProdutor(id) {
  const result = await api.get(`/ativar/${id}`);
  return result.data;
}
export async function desativar(id) {
  const result = await api.get(`/desativar/${id}`);
  return result.data;
}

//Cadastrando uma categoria
export async function category(data) {
  const result = await api.post("/category", data);

  return result.data;
}

export async function RibbonBadges(data) {
  const result = await api.post("/ribbonBadgesCad", data);

  return result.data;
}

export async function categoryType(data) {
  const result = await api.post("/categoriesType", data);

  return result.data;
}


//Deletando uma categoria
export async function deleteCategory(cat) {
  try {
    await api.delete(`/categories/delete/${cat.id}`);
  } catch (err) { }
}
export async function deleteEvento(cat) {
  try {
    await api.delete(`/evento/delete/${cat.id}`);
  } catch (err) { }
}

export async function deleteRibbonDelete(cat) {
  try {
    await api.delete(`/ribbonBadgesDelete/${cat.id}`);
  } catch (err) { }
}

export async function deleteCategoryType(cat) {
  try {
    await api.delete(`/categoriesType/delete/${cat.id}`);
  } catch (err) { }
}

export async function deletePartner(partner) {
  try {
    await api.delete(`/partner/delete/${partner.id}`);
  } catch (err) { }

}
export async function deletePessoas(partner) {
  try {
    await api.delete(`/divulgacao/${partner.id}`);
  } catch (err) { }

}

export async function deleteBanner(banner) {
  try {
    await api.delete(`/delete/banner/${banner.id}`);
  } catch (err) { }
}

//Deletando uma forma de pagamento
export async function deletePayment(pay) {
  try {
    await api.delete(`/paymentMethod/delete/${pay.id}`);
  } catch (err) { }
}

//Pegando todas as localidades
export async function getAllLocations(page = 1) {
  const result = await api.get("/citys", {
    params: {
      page,
    },
  });

  return result.data;
}

//Pegando Informações da Loja
export async function getStore(id, dados, page = 1) {
  const result = await api.post(`/profileStore/${id}`, dados, {
    params: {
      page,
    },
  });
  const data = result.data;

  return data;
}

//Pegando Categorias da Loja
export async function getStoreCategories(id) {
  const result = await api.get(`/profileStoreCategories/${id}`);
  const data = result.data;

  return data;
}
export async function createOrderServico(payload) {
  const result = await api.post("/pedidoServico", payload);
  return result.data;
}

//Criando Pedido
export async function createOrder(payload) {
  const result = await api.post("/order", payload);
  return result.data;
}

//Pegando Informações do Pedido
export async function getOrder(id) {
  const result = await api.get(`/order/${id}`);
  return result.data;
}

//Confirmando o Pagamento do Pedido
export async function confirmOrderPayment(payload) {
  const result = await api.post(`/order/payment`, payload);
  return result.data;
}
export async function CancelPayment(payload) {
  const result = await api.post(`/order/paymentCancel`, payload);
  return result.data;
}

//Pegando o PDF Comprovante do Pedido
export async function pdfOrderPayment(id) {
  const result = await api.get(`/pdf/order/${id}`, {
    headers: { Accept: "application/pdf" },
    responseType: "blob",
  });
  return result.data;
}

export async function loyaltyCardClientPdf(id) {
  const result = await api.get(`/createPdfLoyaltyCard/${id}`, {
    headers: { Accept: "application/pdf" },
    responseType: "blob",
  });
  return result.data;
}

export async function deleteLoyaltyCardClient(id) {
  const result = await api.delete(`/loyaltyCardClient/user/delete/${id}`);
  return result.data;
}

// Todos os Cartões Fidelidades (Empreendedor)
export async function getMyLoyaltyCards() {
  const result = await api.get(`/loyaltyCards/entrepreneur`);
  return result.data.data;
}

// Pegar um Cartão Fidelidade (Empreendedor)
export async function getLoyaltyCard(id) {
  const result = await api.get(`/loyaltyCard/entrepreneur/${id}`);
  return result.data[0][0];
}

// Criar Cartão Fidelidade (Empreendedor)
export async function createLoyaltyCard(payload) {
  if (payload.status === "disponivel") {
    await api.get(`/loyaltyCard/entrepreneur/desativar/`).then(async () => {
      return await api.post(`/loyaltyCard/entrepreneur/`, payload);
    });
    return false;
  }
  const result = await api.post(`/loyaltyCard/entrepreneur/`, payload);
  return result.data;
}
export async function verificaCartaoCliente(id) {
  const result = await api.post("/loyaltyCardClient/verifica", {
    id: id
  });
  return result.data;
}

// Atualizar Cartão Fidelidade (Empreendedor)
export async function updateLoyaltyCard(payload) {
  if (payload.status === "disponivel") {
    await api.get(`/loyaltyCard/entrepreneur/desativar/`).then(async () => {
      return await api.post(
        `/loyaltyCard/entrepreneur/update/${payload.id}`,
        payload
      );
    });
    return false;
  }
  const result = await api.post(
    `/loyaltyCard/entrepreneur/update/${payload.id}`,
    payload
  );
  return result.data;
}

// Deletar Cartão Fidelidade (Empreendedor)
export async function deleteLoyaltyCard(id) {
  const result = await api.delete(`/loyaltyCard/entrepreneur/delete/${id}`);
  return result.data;
}

// Desativar todos os Cartões Fidelidades (Empreendedor)
export async function disableAllLoyaltyCards() {
  const result = await api.get(`/loyaltyCard/entrepreneur/desativar/`);
  return result.data;
}

// Ativar um Cartão Fidelidade (Empreendedor)
export async function activateLoyaltyCard(id) {
  await api.get(`/loyaltyCard/entrepreneur/desativar/`).then(async () => {
    return await api.get(`/loyaltyCard/entrepreneur/ativar/${id}`).data;
  });
  return false;
}

// Verificação da disponibilidade de uso do CPF
export async function availableCpf(cpfUser) {
  const result = await api.post(`/userCpfAvailable`, {
    cpf: cpfUser,
  });
  return result.data;
}

export async function availableCpfCnpj(cpfCnpj) {
  const result = await api.post(`/entrepreneurCpfCnpjAvailable`, {
    cpf_cnpj: cpfCnpj,
  });
  return result.data;
}
export async function availablePhone(telephone) {
  const result = await api.post(`/entrepreneurPhoneAvailable`, {
    telephone: telephone,
  });
  return result.data;
}

// Verificação da disponibilidade de uso do E-mail
export async function availableEmail(email) {
  const result = await api.get(`/userEmailAvailable`, {
    params: {
      email,
    },
  });
  return result.data;
}

export async function availableEmailEntrepreneur(email) {
  const result = await api.post(`/entrepreneurEmailAvailable`, {
    email: email,
  });
  return result.data;
}

// Solicita a recuperação de senha
export async function forgotPassword(email) {
  const result = await api.post("/forgot", {
    email: email,
  });
  return result.data;
}

// Atualiza a senha
export async function newPassword(data) {
  const result = await api.post("/newPassword", data);
  return result.data;
}

// Minhas compras
export async function myPurchases() {
  const result = await api.get("/myShoppingClient");
  return result.data;
}

// Meus Cartões Fidelidade (Cliente)
export async function getMyLoyaltyCardsClient() {
  const result = await api.get(`/loyaltyCardClient/user`);
  return result.data;
}

export async function getCheckoutEntrpreneurInfo(id) {
  const result = await api.get(`/checkout/entrepreneur/${id}`);
  return result.data;
}

// Meus Pedidos (Empreendedor)
export async function myOrders() {
  const result = await api.get(`/orders`);
  return result.data;
}
export async function submitLeadProductRequest(payload) {
  const result = await api.post("/lead-product-requests", payload);
  return result.data;
}
// --- Leads & Promoções CRM ---
export async function getLeads() {
  const result = await api.get(`/leads`);
  return result.data;
}

export async function getLeadRequestsGroupedByCategory() {
  const result = await api.get(`/leads/resumo/categorias`);
  return result.data;
}

export async function getLeadRequestsGroupedByProduct() {
  const result = await api.get(`/leads/resumo/produtos`);
  return result.data;
}

export async function createLead(payload) {
  const result = await api.post(`/leads`, payload);
  return result.data;
}

export async function updateLead(id, payload) {
  const result = await api.put(`/leads/${id}`, payload);
  return result.data;
}

export async function deleteLead(id) {
  const result = await api.delete(`/leads/${id}`);
  return result.data;
}

export async function getPromocoes() {
  const result = await api.get(`/promocoes`);
  return result.data;
}

export async function createPromocao(payload) {
  const result = await api.post(`/promocoes`, payload);
  return result.data;
}

export async function updatePromocao(id, payload) {
  const result = await api.put(`/promocoes/${id}`, payload);
  return result.data;
}

export async function deletePromocao(id) {
  const result = await api.delete(`/promocoes/${id}`);
  return result.data;
}

export async function getHistoricoMensagens() {
  const result = await api.get(`/historico-mensagens`);
  return result.data;
}

export async function enviarTemplateParaTodos() {
  const result = await api.post(`/whatsapp/enviar-template-para-todos`);
  return result.data;
}

export async function enviarPromocoesParaLeadsInteressados() {
  const result = await api.post(`/whatsapp/enviar-promocoes-para-leads`);
  return result.data;
}

export async function enviarPromocoesParaLead(id) {
  const result = await api.get(`/enviarPromocoesParaLead/${id}`);
  return result.data;
}

export async function enviarTemplateParaLead(id) {
  const result = await api.post(`/whatsapp/enviar-template-para-lead/${id}`);
  return result.data;
}
export async function enviarMensagemPersonalizada({ leadIds, mensagem }) {
  const payload = {
    lead_ids: Array.isArray(leadIds) ? leadIds : [],
    mensagem,
  };

  const result = await api.post(`/whatsapp/enviar-mensagem-personalizada`, payload);
  return result.data;
}

export async function getAutomationSettings() {
  const result = await api.get(`/automation/settings`);
  return result.data;
}

export async function updateAutomationSettings({ ai_responses_enabled }) {
  const result = await api.post(`/automation/settings`, {
    ai_responses_enabled,
  });
  return result.data;
}
export async function importLeads(payload) {
  const result = await api.post(`/leads/import`, payload);
  return result.data;
}
export async function consultarLimitesMensagensWhatsApp() {
  const result = await api.get(`/whatsapp/limites-mensagens`);

  return result.data;
}

export async function consultarStatusFilaWhatsApp() {
  const result = await api.get(`/whatsapp/status-fila`);

  return result.data;
}
export async function enviarTemplateParaLeads({ leadIds, async = true, lote = 1000 }) {
  const payload = {
    lead_ids: Array.isArray(leadIds) ? leadIds : [],
    async,
    lote,
  };

  const result = await api.post(`/whatsapp/enviar-template-para-leads`, payload);
  return result.data;
}

/* ============================================================================
 * WhatsApp Web (microserviço Node + wwebjs) — disparo em GRUPOS
 * Coexiste com o sistema atual de Cloud API. NÃO substitui.
 * ============================================================================
 */

export async function listWhatsAppWebChannels() {
  const result = await api.get('/whatsapp-web/channels');
  return result.data;
}

export async function createWhatsAppWebChannel({ name, security = false, channel_type = 'WEB' }) {
  const result = await api.post('/whatsapp-web/channels', { name, security, channel_type });
  return result.data;
}

export async function getWhatsAppWebChannel(id) {
  const result = await api.get(`/whatsapp-web/channels/${id}`);
  return result.data;
}

export async function updateWhatsAppWebChannel(id, payload) {
  const result = await api.put(`/whatsapp-web/channels/${id}`, payload);
  return result.data;
}

export async function deleteWhatsAppWebChannel(id) {
  const result = await api.delete(`/whatsapp-web/channels/${id}`);
  return result.data;
}

export async function startWhatsAppWebSession(id) {
  const result = await api.post(`/whatsapp-web/channels/${id}/start-session`);
  return result.data;
}

export async function getWhatsAppWebQR(id) {
  const result = await api.get(`/whatsapp-web/channels/${id}/qr`);
  return result.data;
}

export async function getWhatsAppWebStatus(id) {
  const result = await api.get(`/whatsapp-web/channels/${id}/status`);
  return result.data;
}

export async function disconnectWhatsAppWebChannel(id) {
  const result = await api.post(`/whatsapp-web/channels/${id}/disconnect`);
  return result.data;
}

export async function getWhatsAppWebChannelDeviceInfo(id) {
  const result = await api.get(`/whatsapp-web/channels/${id}/device-info`);
  return result.data;
}

export async function getWhatsAppWebChannelContacts(id) {
  // 202 = "syncing" — não é erro, vamos retornar o body pra UI tratar
  const result = await api.get(`/whatsapp-web/channels/${id}/contacts`, {
    validateStatus: (s) => s >= 200 && s < 300,
  });
  return result.data;
}

// --- Grupos ---

export async function listWhatsAppWebGroups({ page = 1, pageSize = 30, search = '', channelId = null } = {}) {
  const params = { page, pageSize };
  if (search) params.search = search;
  if (channelId) params.channel_id = channelId;
  const result = await api.get('/whatsapp-web/groups', { params });
  return result.data;
}

export async function syncWhatsAppWebGroups(channelId) {
  const result = await api.post(
    `/whatsapp-web/channels/${channelId}/sync-groups`,
    {},
    { validateStatus: (s) => s >= 200 && s < 300 }
  );
  return result.data;
}

export async function enrichWhatsAppWebGroups(channelId, jids) {
  const result = await api.post(
    `/whatsapp-web/channels/${channelId}/groups-enriched`,
    { jids }
  );
  return result.data;
}

// --- Segmentos ---

export async function listWhatsAppWebSegments() {
  const result = await api.get('/whatsapp-web/segments');
  return result.data;
}

export async function getWhatsAppWebSegment(id) {
  const result = await api.get(`/whatsapp-web/segments/${id}/details`);
  return result.data;
}

export async function createWhatsAppWebSegment(payload) {
  const result = await api.post('/whatsapp-web/segments', payload);
  return result.data;
}

export async function updateWhatsAppWebSegment(id, payload) {
  const result = await api.put(`/whatsapp-web/segments/${id}`, payload);
  return result.data;
}

export async function deleteWhatsAppWebSegment(id) {
  const result = await api.delete(`/whatsapp-web/segments/${id}`);
  return result.data;
}

export async function validateWhatsAppWebSegment(id) {
  const result = await api.post(`/whatsapp-web/segments/${id}/validate`);
  return result.data;
}

// --- Campanhas ---

export async function listWhatsAppWebCampaigns({ page = 1, pageSize = 10, status = '' } = {}) {
  const params = { page, pageSize };
  if (status) params.status = status; // CSV: "sent,error,cancelled,interrupted"
  const result = await api.get('/whatsapp-web/campaigns', { params });
  return result.data;
}

export async function createWhatsAppWebCampaign(payload) {
  const result = await api.post('/whatsapp-web/campaigns', payload);
  return result.data;
}

export async function getWhatsAppWebCampaign(id) {
  const result = await api.get(`/whatsapp-web/campaigns/${id}`);
  return result.data;
}

export async function getWhatsAppWebCampaignDispatches(id) {
  const result = await api.get(`/whatsapp-web/campaigns/${id}/groups`);
  return result.data;
}

export async function cancelWhatsAppWebCampaign(id) {
  const result = await api.post(`/whatsapp-web/campaigns/${id}/cancel`);
  return result.data;
}

export async function deleteWhatsAppWebCampaign(id) {
  const result = await api.delete(`/whatsapp-web/campaigns/${id}`);
  return result.data;
}

// --- Upload ---

export async function uploadWhatsAppWebMedia(file) {
  const fd = new FormData();
  fd.append('file', file);
  const result = await api.post('/whatsapp-web/upload', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return result.data;
}

// --- Integrações de afiliado ---

export async function listWhatsAppWebIntegrations() {
  const result = await api.get('/whatsapp-web/integrations');
  return result.data;
}

export async function getWhatsAppWebIntegrationFields() {
  const result = await api.get('/whatsapp-web/integrations/fields');
  return result.data;
}

export async function createWhatsAppWebIntegration(payload) {
  const result = await api.post('/whatsapp-web/integrations', payload);
  return result.data;
}

export async function updateWhatsAppWebIntegration(id, payload) {
  const result = await api.put(`/whatsapp-web/integrations/${id}`, payload);
  return result.data;
}

export async function deleteWhatsAppWebIntegration(id) {
  const result = await api.delete(`/whatsapp-web/integrations/${id}`);
  return result.data;
}

// --- Multi Sender ---

export async function promoteWhatsAppWebUrl(productUrl) {
  const result = await api.post('/whatsapp-web/promote', {
    product_url: productUrl,
    all_infos: true,
  });
  return result.data;
}

// --- Templates ---

export async function listWhatsAppWebTemplates() {
  const result = await api.get('/whatsapp-web/templates');
  return result.data;
}

export async function createWhatsAppWebTemplate(payload) {
  const result = await api.post('/whatsapp-web/templates', payload);
  return result.data;
}

export async function updateWhatsAppWebTemplate(id, payload) {
  const result = await api.put(`/whatsapp-web/templates/${id}`, payload);
  return result.data;
}

export async function deleteWhatsAppWebTemplate(id) {
  const result = await api.delete(`/whatsapp-web/templates/${id}`);
  return result.data;
}

export async function previewWhatsAppWebTemplate(id, productId) {
  const result = await api.post(`/whatsapp-web/templates/${id}/preview`, {
    product_id: productId,
  });
  return result.data;
}

// --- Blacklist ---

export async function listWhatsAppWebBlacklist() {
  const result = await api.get('/whatsapp-web/blacklist');
  return result.data;
}

export async function addWhatsAppWebBlacklist(phone, reason) {
  const result = await api.post('/whatsapp-web/blacklist', { phone, reason });
  return result.data;
}

export async function removeWhatsAppWebBlacklist(id) {
  const result = await api.delete(`/whatsapp-web/blacklist/${id}`);
  return result.data;
}

// --- Group Monitoring ---

export async function listWhatsAppWebMonitoring(segmentId) {
  const result = await api.get(
    `/whatsapp-web/segments/${segmentId}/monitoring`
  );
  return result.data;
}

export async function createWhatsAppWebMonitoring(payload) {
  const result = await api.post('/whatsapp-web/monitoring', payload);
  return result.data;
}

export async function updateWhatsAppWebMonitoring(id, payload) {
  const result = await api.put(`/whatsapp-web/monitoring/${id}`, payload);
  return result.data;
}

export async function deleteWhatsAppWebMonitoring(id) {
  const result = await api.delete(`/whatsapp-web/monitoring/${id}`);
  return result.data;
}

// --- Statistics ---

export async function getWhatsAppWebStatistics(days = 30) {
  const result = await api.get('/whatsapp-web/statistics', { params: { days } });
  return result.data;
}

// --- Disparar a partir de Product ---

export async function dispatchProductToWhatsApp(productId, payload) {
  const result = await api.post(
    `/whatsapp-web/products/${productId}/dispatch`,
    payload
  );
  return result.data;
}

// --- Serviço WhatsApp (microserviço Node) ---

export async function getWhatsAppWebService() {
  const result = await api.get('/whatsapp-web/service');
  return result.data;
}

export async function updateWhatsAppWebService(payload) {
  const result = await api.put('/whatsapp-web/service', payload);
  return result.data;
}

export async function testWhatsAppWebService(payload = {}) {
  const result = await api.post('/whatsapp-web/service/test', payload, {
    timeout: 20000,
  });
  return result.data;
}

export async function getWhatsAppWebServiceHealth() {
  const result = await api.get('/whatsapp-web/service/health', {
    timeout: 20000,
  });
  return result.data;
}

export async function getWhatsAppWebServiceRoutes() {
  const result = await api.get('/whatsapp-web/service/routes');
  return result.data;
}

export async function getWhatsAppWebServiceOverview(days = 30) {
  const result = await api.get('/whatsapp-web/service/overview', {
    params: { days },
    timeout: 20000,
  });
  return result.data;
}